import React, { useEffect, useState } from 'react';
import api from '../api';
import { Badge } from '../ui';
import { useLang } from '../Layout';

const T = {
  bn: { attendance: 'আমার হাজিরা', salary: 'আমার বেতন', advances: 'আমার অগ্রিম', total: 'মোট অগ্রিম', week: 'সপ্তাহ', days: 'দিন কাজ', empty: 'কোনো তথ্য নেই।', emptyA: 'কোনো অগ্রিম নেই।', prev: 'আগের বাকি' },
  en: { attendance: 'My Attendance', salary: 'My Salary', advances: 'My Advances', total: 'Total Advances', week: 'Week', days: 'days worked', empty: 'No data yet.', emptyA: 'No advances yet.', prev: 'Previous balance' },
};

export function MyAttendance() {
  const { lang } = useLang(); const t = T[lang];
  const [list, setList] = useState([]);
  useEffect(() => { api.get('/worker/attendance').then(({ data }) => setList(data.attendance)).catch(() => {}); }, []);
  return (
    <div className="space-y-5">
      <h1 className="text-xl font-semibold text-[#0F172A]">{t.attendance}</h1>
      <div className="bg-white rounded-xl shadow-[0_1px_3px_rgba(0,0,0,0.08)] overflow-hidden">
        <table className="charm-table"><thead><tr><th>Date</th><th>Status</th></tr></thead>
          <tbody>{list.map((a, i) => (<tr key={i}><td className="font-medium text-[#0F172A]">{a.date}</td><td><Badge color={a.status}>{a.status}</Badge></td></tr>))}</tbody>
        </table>
        {list.length === 0 && <div className="text-center py-12 text-[#94A3B8] text-sm">{t.empty}</div>}
      </div>
    </div>
  );
}

export function MySalary() {
  const { lang } = useLang(); const t = T[lang];
  const [list, setList] = useState([]);
  useEffect(() => { api.get('/worker/salary').then(({ data }) => setList(data.salary)).catch(() => {}); }, []);
  const fmt = (n) => '৳' + Number(n || 0).toLocaleString();
  return (
    <div className="space-y-5">
      <h1 className="text-xl font-semibold text-[#0F172A]">{t.salary}</h1>
      <div className="space-y-3">
        {list.map((s, i) => (
          <div key={i} className="bg-white rounded-xl shadow-[0_1px_3px_rgba(0,0,0,0.08)] p-5">
            <div className="flex justify-between items-center">
              <div><div className="font-medium text-[#0F172A]">{t.week}: {s.week_start}</div><div className="text-xs text-[#94A3B8]">{s.days_worked} {t.days}</div></div>
              <div className="text-right"><div className="text-lg font-bold text-[#0F172A]">{fmt(s.net_amount)}</div><Badge color={s.status}>{s.status}</Badge></div>
            </div>
            {s.balance_forward > 0 && <div className="text-xs text-[#F59E0B] mt-1">{t.prev}: {fmt(s.balance_forward)}</div>}
          </div>
        ))}
        {list.length === 0 && <div className="text-center py-12 text-[#94A3B8] text-sm">{t.empty}</div>}
      </div>
    </div>
  );
}

export function MyAdvances() {
  const { lang } = useLang(); const t = T[lang];
  const [list, setList] = useState([]);
  const [total, setTotal] = useState(0);
  useEffect(() => { api.get('/worker/advances').then(({ data }) => { setList(data.advances); setTotal(data.total); }).catch(() => {}); }, []);
  const fmt = (n) => '৳' + Number(n || 0).toLocaleString();
  return (
    <div className="space-y-5">
      <h1 className="text-xl font-semibold text-[#0F172A]">{t.advances}</h1>
      <div className="bg-white rounded-xl shadow-[0_1px_3px_rgba(0,0,0,0.08)] p-5 text-center">
        <div className="text-xs font-medium text-[#94A3B8] uppercase tracking-wide">{t.total}</div>
        <div className="text-3xl font-bold text-[#0F172A] mt-1">{fmt(total)}</div>
      </div>
      <div className="space-y-3">
        {list.map((a, i) => (
          <div key={i} className="bg-white rounded-xl shadow-[0_1px_3px_rgba(0,0,0,0.08)] p-4 flex justify-between items-center">
            <div className="flex items-center gap-3"><div className="w-9 h-9 rounded-lg bg-[#FFFBEB] text-[#F59E0B] flex items-center justify-center">💰</div>
              <div><div className="font-medium text-[#0F172A]">{fmt(a.amount)}</div><div className="text-xs text-[#94A3B8]">{a.date} {a.note ? `• ${a.note}` : ''}</div></div>
            </div>
          </div>
        ))}
        {list.length === 0 && <div className="text-center py-12 text-[#94A3B8] text-sm">{t.emptyA}</div>}
      </div>
    </div>
  );
}